module.exports = __webpack_public_path__ + "img/shenheshibai.0c494f0d.png";